import request from 'utils/request'

/**
 * 查询基本详情
 * @param {*} data
 */
export const queryBase = data => request().get(`bp/apply/queryBase/${data}`)
